"use client";

import { useTranslations } from "next-intl";
import React from "react";
import { cn } from "../../../helpers/classNames";
import { Button } from "../../Button";
import { useOpenCMP } from "../../Consent/hooks";
import styles from "./styles.module.scss";

export const CmpLink: React.FC = () => {
    const t = useTranslations("component.footer");
    const openCMP = useOpenCMP();

    return (
        <li key="footer-cmp-link" className={styles.linkLi}>
            <Button
                variant="unstyled"
                data-label="Privatsphäre Einstellungen"
                aria-label={t("internals.openSettings")}
                title={t("internals.openSettings")}
                className={cn(styles.footerButton, "cmp-lnk-recall")}
                onClick={(): void => openCMP()}
                data-tracking-id="footer-open-cmp"
            >
                {t("internals.openSettings")}
            </Button>
        </li>
    );
};
